export const INITIAL_FETCH_EMPLOYEE = "INITIAL_FETCH_EMPLOYEE";
export const SET_EMPLOYEE_PAGE = "SET_EMPLOYEE_PAGE";
export const SET_EMPLOYEE_SEARCH = "SET_SEARCH_EMPLOYEE";
export const SET_EMPLOYEE_ROW_COUNT = "SET_EMPLOYEE_ROW_COUNT";
